
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/custom/index.md?watch=parent';
    export const toc = [{"id":"自定义组件","depth":2,"title":"自定义组件"}];
export const frontmatter = {"title":"自定义组件","toc":"menu","filename":"pages/pages/reference/custom/index.md","lastUpdated":1773900960000,"description":"这是一个带有自定义组件的动态表格"};